import { __assign } from "tslib";
import { LINK_TEXT_REGEXP } from '../tokenize/link-text';
var defaultWidth = 200;
var defaultHeight = 183;
export default function getMediaSingleNodeView(schema, filename, attrs, context) {
    if (context === void 0) { context = {}; }
    var _a = schema.nodes, media = _a.media, mediaSingle = _a.mediaSingle;
    var mediaNodeAttrs = {
        width: defaultWidth,
        height: defaultHeight,
    };
    var mediaSingleAttrs = { layout: 'center' };
    if (attrs.width && attrs.width.endsWith('%')) {
        var parsed = parseInt(attrs.width, 10);
        if (!isNaN(parsed)) {
            mediaSingleAttrs.width = parsed;
        }
        mediaNodeAttrs = {};
    }
    else {
        if (attrs.width) {
            var parsed = parseInt(attrs.width, 10);
            if (!isNaN(parsed)) {
                mediaNodeAttrs.width = parsed;
            }
        }
        if (attrs.height) {
            var parsed = parseInt(attrs.height, 10);
            if (!isNaN(parsed)) {
                mediaNodeAttrs.height = parsed;
            }
        }
    }
    if (attrs.alt) {
        // strip wrapping quotes if they exist
        var altText = attrs.alt.replace(/^"(.+)"$/, '$1');
        mediaNodeAttrs.alt = altText;
    }
    if (filename.match(LINK_TEXT_REGEXP)) {
        var externalMediaNode = media.createChecked(__assign({ type: 'external', url: filename }, mediaNodeAttrs));
        return mediaSingle.createChecked(mediaSingleAttrs, externalMediaNode);
    }
    else {
        var id = context.conversion &&
            context.conversion.mediaConversion &&
            context.conversion.mediaConversion[filename]
            ? context.conversion.mediaConversion[filename]
            : filename;
        // try to look up collection from media context
        var collection = context.hydration &&
            context.hydration.media &&
            context.hydration.media.targetCollectionId;
        var mediaNode = media.createChecked(__assign({ id: id, type: 'file', collection: collection || '' }, mediaNodeAttrs));
        return mediaSingle.createChecked(mediaSingleAttrs, mediaNode);
    }
}
//# sourceMappingURL=mediaSingle.js.map